(function () {
	function swiperInit() {
    const onlyShowImages = typeof variantImagesMetaFields[activeVariantSku] !== 'undefined' && variantImagesMetaFields[activeVariantSku].length
      ? variantImagesMetaFields[activeVariantSku]
      : undefined;

		subSliderInit(true, onlyShowImages);
		sliderInit(true, onlyShowImages);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
		$('.js-media-list').each(function () {
			this.swiper.destroy();
		});
		$('.js-media-sublist').each(function () {
			this.swiper.destroy();
		});

		swiperInit();
	});

	swiperInit();
})();
